/* global process */

const rawApiBaseUrl = process.env.VUE_APP_API_BASE_URL || "http://localhost:8765";
const rawGraficoswsApiUrl = process.env.VUE_APP_GRAFICOSWS_API_URL || "http://localhost:4000";

export const API_BASE_URL = rawApiBaseUrl.replace(/\/+$/, "");
export const GRAFICOSWS_API_URL = rawGraficoswsApiUrl.replace(/\/+$/, "");
